module.exports = __webpack_public_path__ + "img/Kreuzer Nikolaus.jpg";